import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "py-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold text-white capitalize" }, "Dashboard")
], -1)
const _hoisted_2 = { class: "bg-white flex flex-col shadow rounded-lg mt-6 divide-y" }
const _hoisted_3 = { class: "px-4 md:px-6 py-5 flex justify-between items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-gray-900" }, "Latest loan requests", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "text-sky ml-2 text-sm mt-1 font-medium"
}, "All requests", -1)
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = {
  class: "-mb-px flex space-x-4 md:space-x-6 px-6",
  "aria-label": "Tabs"
}
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = { class: "text-gray-600 text-hover-primary mb-1" }
const _hoisted_10 = { class: "text-gray-600 text-hover-primary mb-1" }
const _hoisted_11 = { class: "text-gray-600 text-hover-primary mb-1" }
const _hoisted_12 = { class: "text-gray-600 text-hover-primary mb-1" }
const _hoisted_13 = { class: "text-gray-600" }
const _hoisted_14 = { class: "text-gray-600" }
const _hoisted_15 = { class: "text-gray-600" }
const _hoisted_16 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_data_table = _resolveComponent("data-table")!
  const _component_base_pagination = _resolveComponent("base-pagination")!
  const _component_base_spinner = _resolveComponent("base-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, { to: { name: 'deals'} }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("nav", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, ({ label, filter }, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              href: `#filter-${index}`,
              class: _normalizeClass(["border-transparent text-gray-500 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium flex items-center", _ctx.filtersData.status == filter ? 'border-sky text-sky' : 'hover:border-gray-300 hover:text-gray-700']),
              onClick: _withModifiers(($event: any) => (_ctx.setFilter(filter)), ["prevent"])
            }, _toDisplayString(label), 11, _hoisted_8))
          }), 128))
        ])
      ]),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_data_table, {
            key: 0,
            tableData: _ctx.deals,
            tableHeader: _ctx.tableHeader,
            class: "rounded-bl-lg rounded-br-lg"
          }, {
            "cell-customer": _withCtx(({ row: deal }) => [
              _createElementVNode("div", null, [
                _createElementVNode("span", null, _toDisplayString(deal?.customerData.fullName), 1)
              ])
            ]),
            "cell-amount": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_9, _toDisplayString(deal.data["Loan amount"] ? '$' + _ctx.convertToCurrency(deal.data["Loan amount"]) : '–'), 1)
            ]),
            "cell-purpose": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_10, _toDisplayString(deal.data["Loan purpose"] || '–'), 1)
            ]),
            "cell-state": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_11, _toDisplayString(deal.data["Property address"]?.administrative_area_level_1 || '–'), 1)
            ]),
            "cell-type": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(deal.type), 1)
            ]),
            "cell-status": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_13, _toDisplayString(deal.status), 1)
            ]),
            "cell-created": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.moment(deal.created)), 1)
            ]),
            "cell-updated": _withCtx(({ row: deal }) => [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.moment(deal.updated) || '-'), 1)
            ]),
            "cell-details": _withCtx(({ row: deal }) => [
              _createElementVNode("div", _hoisted_16, [
                (deal.offeringMemorandumId)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "px-3 py-2 bg-white border text-xs rounded-md hover:border-gray-400 mr-2 flex items-center",
                      to: `/offering-memorandum/${deal.offeringMemorandumId || ''}`
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_EyeIcon, { class: "w-3 h-3 mr-1" }),
                        _createTextVNode(" OM ")
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: { name: 'deal', params: { id: deal.id } },
                  class: "py-2 px-3 bg-sky text-white text-xs rounded-md focus:outline-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Details ")
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            _: 1
          }, 8, ["tableData", "tableHeader"]))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_base_pagination, {
            key: 1,
            pagingData: _ctx.paging,
            onCurrentChange: _ctx.onPageChange
          }, null, 8, ["pagingData", "onCurrentChange"]))
        : (_openBlock(), _createBlock(_component_base_spinner, {
            key: 2,
            class: "h-80 rounded-bl-lg rounded-br-lg"
          }))
    ])
  ], 64))
}